import React, { createElement, PureComponent } from 'react';
import PropTypes from 'prop-types';
import debounce from 'lodash/debounce';

import Box from '../Box';
import Input from '../Input';
import Image from '../Image';
import checkImage from '../utils/checkImage';

class TextInput extends PureComponent {
  constructor(props) {
    super(props);
    this.formikChange = debounce(this.formikChange, 300)
  }

  state = {
    value: this.props.value
  }

  handleChange = (e) => {
    this.setState({ value: e.target.value });
    e.persist()
    this.formikChange(e)
  }

  formikChange = (e) => {
    this.props.onChange(e)
  }

  render() {
    const {
      placeholder,
      disabled,
      textAlign,
      autoComplete,
      textarea,
      form,
      required,
      onChange,
      onBlur,
      name,
      value,
      values,
      touched,
      readOnly,
      preventSubmit,
      src,
      setOtherValue,
      ...props
    } = this.props;
    return (
      <Box px="0.5em" {...props}>
        {src && <Image mb="2em" src={checkImage(src)} />}
        {createElement(Input, {
          placeholder,
          disabled,
          textAlign,
          autoComplete,
          onChange: this.handleChange,
          onBlur,
          value: this.state.value,
          name,
          is: textarea ? 'textarea' : 'input',
          rows: 6,
          readOnly,
          onKeyDown: (e) => e.keyCode === 13 && !textarea && preventSubmit && e.preventDefault(),
        })}
      </Box>
    );
  }
}

TextInput.propTypes = {
  label: PropTypes.string,
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
  textarea: PropTypes.bool,
};

TextInput.defaultProps = {
  placeholder: '請填入文字',
};

export default TextInput;
